// extracted by mini-css-extract-plugin
export var dataCell = "_qt-2";
export var dataRow = "_qt-0";
export var headerRow = "_qt-1";